import React from 'react';
import CheckBox from '../CheckBox';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

const CheckboxListItem = ({ data, selectItem, selectedItems, caption }) => {
    function handleSelect() {
        selectItem(data);
    }

    return (
        <Grid item xs={6}>
            <CheckBox
                label={data.name}
                onChange={handleSelect}
                checked={!!selectedItems?.find((item) => +item === data.id)}
            />
            {caption ? (
                <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ display: 'block', pl: 4, mt: -0.5 }}
                >
                    {caption}
                </Typography>
            ) : null}
        </Grid>
    )
}

export default CheckboxListItem
